import React, { Component } from 'react';
import { Modal, Form, Button, Row, Col,Image, Container } from 'react-bootstrap';
import Backend from '../../Backend';
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce } from 'react-activity';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import Connection from '../../Calls';

import Check from '../../Images/check.svg';
import CheckCorrect from '../../Images/check-correct.svg';
import GAuth from '../../Images/gauth.png'


class Modaltwofa extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoad: false,
      displayedScreen:'login'
    }
  }

  loginFunc() {
    var code
    if(this.state.digit1 && this.state.digit2 && this.state.digit3 && this.state.digit4 && this.state.digit5 && this.state.digit6){
        code = this.state.digit1 + this.state.digit2 + this.state.digit3 + this.state.digit4 + this.state.digit5 + this.state.digit6
    }else{
        code = '-'
    }
    this.setState({
      showLoad: false,
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
     });
    this.props.TowFAConfirm(code);
  }

  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.loginFunc()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

  cancelLogIn(){
    this.setState({
      showLoad: false,
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
     });
    this.props.TowFAConfirm('cancel');
  }

  renderContent(){
    return(
        <>
          <div className="border-title-separator-container-left" style={{ width: "100%" }}>
            <p className="title-container-shadow">Confirm 2FA</p>
          </div>
          <div className='activate-2fa-titles'>
            <div className='gauth_logo inline-block'>
              <Image src={GAuth}/>
            </div>
            <div className='inline-block'>
              <p className='password-notice'>Input the 6-digit code from your Google Authenticator App</p>
            </div>
          </div>
          <div style={{ marginTop: 25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Container className="container-google-autenticathor">
              <Row>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref1'
                    ref='digit_ref1'
                    maxlength='1'
                    value={this.state.digit1}
                    onChange={(digit1) => {this._handleChange(1,digit1)}}
                  />
                </Col>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref2'
                    ref='digit_ref2'
                    maxlength='1'
                    value={this.state.digit2}
                    onChange={(digit2)=> {this._handleChange(2,digit2)}}
                    onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
                  />
                </Col>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref3'
                    ref='digit_ref3'
                    maxlength='1'
                    value={this.state.digit3}
                    onChange={(digit3) => {this._handleChange(3,digit3)}}
                    onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
                  />
                </Col>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref4'
                    ref='digit_ref4'
                    maxlength='1'
                    value={this.state.digit4}
                    onChange={(digit4) => {this._handleChange(4,digit4)}}
                    onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
                  />
                </Col>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref5'
                    ref='digit_ref5'
                    maxlength='1'
                    value={this.state.digit5}
                    onChange={(digit5) => { this._handleChange(5,digit5)}}
                    onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
                  />
                </Col>
                <Col xs={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref6'
                    ref='digit_ref6'
                    maxlength='1'
                    value={this.state.digit6}
                    onChange={(digit6) => { this._handleChange(6,digit6)}}
                    onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div style={{ marginTop: 30, textAlign: "center" }}>
            <Button className="label-signup-link" variant="link" onClick={() => this.cancelLogIn()}>Cancel</Button>
          </div>
        </>
      )
  }



  render() {
    return (
      <div>
        {
          (this.props.modal)
          ?
          <Modal className='modal-transfer-twofa' centered aria-labelledby="contained-modal-title-vcenter" show={this.props.showModalTwofa} onHide={() => { this.cancelLogIn() }}>
            <Modal.Body>
              {this.renderContent()}
            </Modal.Body>
          </Modal>
          : this.renderContent()
        }
      </div>
    );
  }
} export default Modaltwofa;
